var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('Title'),_c('EditTerms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }